import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

// Async thunk for fetching countries
export const fetchCountries = createAsyncThunk(
  'countries/fetchCountries',
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient({
        url: API_ENDPOINTS.GET_COUNTRIES,
        method: 'get',
        withAuth: true,
      });
      
      return res?.data?.countries?.map((item) => ({
        label: item.name,
        value: item.iso2,
      })) || [];
    } catch (error) {
      console.error('Country fetch error:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch countries');
    }
  }
);

const countriesSlice = createSlice({
  name: 'countries',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetched = Date.now();
        state.error = null;
      })
      .addCase(fetchCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = countriesSlice.actions;
export default countriesSlice.reducer;
